import { render, staticRenderFns } from "./Guideboard.vue?vue&type=template&id=354f8f95&scoped=true&"
var script = {}
import style0 from "./Guideboard.vue?vue&type=style&index=0&id=354f8f95&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f8f95",
  null
  
)

export default component.exports